const storageKey = 'contact-attribution-v1'
const campaignFields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid']
let arrival

export function captureContactAttribution() {
  if (typeof window === 'undefined' || arrival) return

  try {
    const saved = JSON.parse(window.sessionStorage.getItem(storageKey))
    if (saved && typeof saved.landing_url === 'string') {
      arrival = saved
      return
    }
  } catch (_) {
    // Attribution must not prevent submissions when storage is unavailable.
  }

  const params = new URLSearchParams(window.location.search)
  arrival = {
    landing_url: window.location.href.slice(0, 8192),
    referrer: document.referrer.slice(0, 8192),
  }
  campaignFields.forEach(field => {
    arrival[field] = (params.get(field) || '').slice(0, 500)
  })

  try {
    window.sessionStorage.setItem(storageKey, JSON.stringify(arrival))
  } catch (_) {
    // Keep the in-memory fallback for this page visit.
  }
}

export function getContactAttribution() {
  if (typeof window === 'undefined') return {}
  captureContactAttribution()
  return { ...arrival, page_url: window.location.href.slice(0, 8192) }
}
